import {
    buildRecentSearchFeed,
    readRecentSearches,
    renderRecentSearches,
} from './recent-searches';

document.addEventListener('DOMContentLoaded', function () {
    const wrap     = document.getElementById('recent-searches-wrap');
    const block    = document.getElementById('recent-searches-block');
    const slider   = document.getElementById('recent-searches-slider');
    const fallback = document.getElementById('recent-searches-fallback-block');

    if (!wrap || !block || !slider) return;

    let tutorialPromos = [];

    try {
        tutorialPromos = JSON.parse(wrap.dataset.tutorialPromos || '[]');
    } catch (e) {
        tutorialPromos = [];
    }

    const items = readRecentSearches();
    const feed  = buildRecentSearchFeed(items, tutorialPromos, {
        maxPromoSlots: tutorialPromos.length,
    });

    if (feed.length > 0) {
        block.style.display = 'block';
        slider.style.display = 'flex';
        slider.innerHTML = '';

        if (fallback) {
            fallback.style.display = 'none';
            fallback.innerHTML = '';
        }

        renderRecentSearches(slider, feed);
        wrap.classList.remove('is-empty');
        return;
    }

    block.style.display = 'none';
    slider.innerHTML = '';

    if (fallback) {
        fallback.style.display = 'block';
    }

    wrap.classList.add('is-empty');
});
